import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { AUTH_CONFIG } from '../features/auth/constants'
import RegistrationForm from '../features/auth/components/RegistrationForm'
import { useUt } from '../context/UtFlagContext'
import { UtAuthFrame } from '../components/ut/auth/UtAuthFrame'

/**
 * Registration page component
 * Shows either the registration form or a message when registration is disabled
 */
const Register: React.FC = () => {
  const location = useLocation()
  // Get the redirect path from location state (set by LockedContent or other CTAs)
  const from = (location.state as { from?: string })?.from
  const { enabled: ut } = useUt()

  if (ut) {
    return AUTH_CONFIG.REGISTRATION_ENABLED ? (
      <UtAuthFrame title="Create account" sub="Get your card, register for games and rate players." wide>
        <RegistrationForm redirectTo={from} />
      </UtAuthFrame>
    ) : (
      <UtAuthFrame title="Registration coming soon" sub="We're fine-tuning sign-ups. Please check back soon.">
        <span className="text-sm text-ut-mut">
          Already have an account?{' '}
          <Link to="/login" state={{ from }} className="text-ut-acc hover:text-ut-ink">
            Sign in
          </Link>
        </span>
      </UtAuthFrame>
    )
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-base-200">
      <div className="card w-96 bg-base-100 shadow-xl">
        <div className="card-body">
          {AUTH_CONFIG.REGISTRATION_ENABLED ? (
            <RegistrationForm redirectTo={from} />
          ) : (
            <div className="text-center space-y-4">
              <h2 className="card-title justify-center mb-4">Registration Coming Soon!</h2>
              <p className="text-base-content/80">
                We're currently fine-tuning our registration system. Please check back soon!
              </p>
              <div className="divider">OR</div>
              <div className="text-sm">
                Already have an account?{' '}
                <Link to="/login" state={{ from }} className="link link-primary">
                  Login here
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Register